import { RemoteI9Type } from '@dtos/remote-i9-type';
import {WorkStatus} from '@models/onboarding-review/section2-document-upload';

export enum RemoteI9Status {
    WORKER_PENDING = 'WORKER_PENDING',
    REPRESENTATIVE_PENDING = 'REPRESENTATIVE_PENDING',
    REPRESENTATIVE_SIGNED = 'REPRESENTATIVE_SIGNED',
    REPRESENTATIVE_DECLINED = 'REPRESENTATIVE_DECLINED',
    RECRUITER_CONFIRMED = 'RECRUITER_CONFIRMED',
    RECRUITER_DECLINED = 'RECRUITER_DECLINED',
    INVALID = 'INVALID',
    REPRESENTATIVE_DOCUMENTS_APPROVED = 'REPRESENTATIVE_DOCUMENTS_APPROVED',
    REPRESENTATIVE_DOCUMENTS_REJECTED = 'REPRESENTATIVE_DOCUMENTS_REJECTED'
}

/**
 * authorized-representative-controller
 * get /external/representative/status
 * Returns the Candidate's I9 Section # status
 */
export interface RemoteI9StatusDetails {
    documentsRequired: boolean;
    status: RemoteI9Status;
    type: RemoteI9Type;
    workStatus: WorkStatus;
    receiptReplacementDocumentRequired: boolean;
    i9Section2Status: string | null;
}



// WEBPACK FOOTER //
// ./src/dtos/remote-i9-status.ts